import { Button } from "@devhop/ui";
import { Plus } from "lucide-react";

type FlowsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function FlowsToolbar({ canManage, onCreate }: FlowsToolbarProps) {
  return (
    <div className="mb-4 flex items-center justify-between">
      <div>
        <h1 className="font-bold text-2xl">Flow</h1>
        <p className="text-muted-foreground text-sm">
          ຈັດການ Flow ແລະ ຂັ້ນຕອນການດໍາເນີນງານ
        </p>
      </div>
      {canManage && (
        <Button onClick={onCreate}>
          <Plus className="mr-2 h-4 w-4" />
          ສ້າງ Flow ໃໝ່
        </Button>
      )}
    </div>
  );
}
